<template>
  <div class="sections--idea-overview">
    <div class="section--idea-overview">
      <div class="container main-content">
        <div class="row">
          <div class="col-lg-3 idea-info d-none d-lg-block">
            <span class="title">Additional info:</span>

            <div class="block">
              <IdeaChecklist :type="'view'" :idea="idea" v-if="loading" :key="`checklist${idea.idContent}`"></IdeaChecklist>
            </div>

<!--            <div class="block" v-if="idea.users">-->
<!--              <span class="label">Authors</span>-->
<!--              <div class="box-user" v-for="(user, index) in idea.users" :key="index">-->
<!--                <div class="box-user-img">-->
<!--                  <img :src="user.avatar">-->
<!--                </div>-->
<!--                <span>{{user.name}}</span>-->
<!--              </div>-->
<!--            </div>-->

            <div class="block" v-if="idea.attachments && idea.attachments.length">
              <span class="label">Attachments</span>
              <div class="attachment-box" v-for="(attachment, index) in idea.attachments" :key="index" v-bind:class="attachmentClassDirectory(attachment.file_type)">
                <div>
                  <span class="attachment-box-name">{{attachment.file_name}}</span>
                  <span class="attachment-box-size">{{attachment.file_size}}</span>
                </div>
                <a class="attachment-box-show" target="_blank" :href="attachment.url"></a>
              </div>
            </div>

<!--            <div class="block">-->
<!--              <a class="link-icon"><i class="icon-report"></i> <span>Report this idea</span></a>-->
<!--            </div>-->
          </div>

          <div class="col-lg-9 idea-content">
            <div class="idea-section">
              <label>Description</label>
              <div v-html="openLinksInNewTab(idea.contentPost)"></div>
            </div>

            <div class="idea-section" v-for="(field) in ideaContentFields" :key="field.idContentField">
              <template v-if="getFieldType(field) !== 'IMAGE'">
                <label>{{displayFieldName(field)}}</label>
                <template v-if="field.value">
                  <div v-html="openLinksInNewTab(field.value)"></div>
                </template>
                <template v-else>
                  <div>{{displayFieldValue(field)}}</div>
                </template>
              </template>
            </div>

            <div class="idea-section" v-if="gallery && gallery.length">
              <label>Additional images</label>
              <Gallery :gallery="gallery" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <Comments v-if="$store.getters.ideaLoaded" :key="idea.idContent"></Comments>

    <div class="section--idea-similar d-none d-lg-block" v-if="similarIdeas.length">
      <div class="container">
        <h2 class="h1">Similar ideas</h2>
        <div class="boxes-row row">
          <div class="col-lg-3"  v-for="idea in similarIdeas" :key="idea.id">
            <IdeaBox :idea="idea"></IdeaBox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {openLinksInNewTab} from "@/helpers/openLinksInNewTab"
import IdeaChecklist from "../../components/ideas/IdeaChecklist";
import Gallery from "../../components/general/Gallery";
import IdeaBox from "@/components/ideas/IdeaBox";
import Comments from "@/components/comments/Comments";
import settings from "@/settings";
export default {
  name: "IdeaOverview",
  components: {Comments, IdeaChecklist, IdeaBox, Gallery},
  data () {
    return {
      galleryIndex: 0,
      galleryShow: false,
      loading: false
    }
  },
  watch: {
    '$store.getters.ideaLoaded'() {
      this.loading = true
    }
  },
  computed: {
    idea() {
      return this.$store.getters.idea
    },
    content() {
      return this.$store.getters.idea._embedded.Content
    },
    similarIdeas() {
      return this.$store.getters.featuredIdeas
    },
    gallery() {
      let gallery = [];
      if(this.content._embedded.ContentFieldValue) {
        this.content._embedded.ContentFieldValue.forEach(item => {
          if(this.getFieldType(item) === 'IMAGE') {
            gallery.push(item)
          }
        })
      }
      return gallery
    },
    ideaContentFields() {
      if(this.idea._embedded.Content && this.idea._embedded.Content._embedded.ContentFieldValue ) {
        return this.idea._embedded.Content._embedded.ContentFieldValue.filter(item => {
          return this.getFieldType(item) !== 'IMAGE'
        })
      }
      return []
    }
  },
  mounted() {
    let params = {
      _embed: 1,
      _idType: this.$store.getters.sectionByCode(settings.MODULES.IDEA_BOARD).idSettingCompany,
      _page: 1,
      _per_page: 20,
      _sort: 'date'
    }
    this.$store.dispatch('getFeaturedIdeas', params)
  },
  methods: {
    openLinksInNewTab: openLinksInNewTab,
    getFieldType(field) {
      let item = this.$store.getters.contentFieldsForIdeaBoard.find(elem => {
        return field.idContentField === elem.idContentField
      })
      return item.fieldType
    },
    displayFieldName(field) {
      let item = this.$store.getters.contentFieldsForIdeaBoard.find(elem => {
        return field.idContentField === elem.idContentField
      })
      return item.name
    },
    displayFieldValue(field) {
      let items = this.$store.getters.contentFieldOptionsForIdeaBoard(field.idContentField)
      let item = items.find(elem => {
        return field.idContentFieldOption === elem.idContentFieldOption
      })
      if(item) {
        return item.value
      }
      return '';
    },
    attachmentClassDirectory(type) {
      switch (type) {
        case 'image/jpeg':
        case 'image':
        case 'image/png':
        case 'image/gif':
          return 'attachment-box--pic'
        case 'application/pdf':
        case 'pdf':
          return 'attachment-box--pdf'
        case 'document':
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessing':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          return 'attachment-box--word'
      }
      return 'attachment-box--default'
    },
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
